import { Form } from 'react-bootstrap';
import TypographyEditor from './editors/TypographyEditor';
import TextSectionEditor from './editors/TextSectionEditor';
import ListEditor from './editors/ListEditor';
import MediaEditor from './editors/MediaEditor';
import LayoutEditor from './editors/LayoutEditor';
import NavigationEditor from './editors/NavigationEditor';
import InteractiveEditor from './editors/InteractiveEditor';

const EDITOR_MAP = {
  // Typography
  heading:      TypographyEditor,
  paragraph:    TypographyEditor,
  html:         TypographyEditor,
  text:         TextSectionEditor,
  quote:        TypographyEditor,
  callout:      TypographyEditor,
  highlightBox: TypographyEditor,
  badge:        TypographyEditor,
  // Lists & Accordions
  bulletList:   ListEditor,
  iconList:     ListEditor,
  faq:          ListEditor,
  accordion:    LayoutEditor,
  toggleBlock:  ListEditor,
  // Media
  image:        MediaEditor,
  carousel:     MediaEditor,
  collage:      MediaEditor,
  video:        MediaEditor,
  audio:        MediaEditor,
  pdf:          MediaEditor,
  // Layout
  hero:         LayoutEditor,
  banner:       LayoutEditor,
  dataCard:     LayoutEditor,
  columns:      LayoutEditor,
  cardGrid:     LayoutEditor,
  // Navigation
  navMenu:      NavigationEditor,
  submenu:      NavigationEditor,
  breadcrumbs:  NavigationEditor,
  footer:       NavigationEditor,
  button:       NavigationEditor,
  // Interactive
  countdown:    InteractiveEditor,
  poll:         InteractiveEditor,
  announcement: InteractiveEditor,
};

export default function BlockEditor({ block, onUpdate }) {
  const { type, content, id } = block;
  const update = (key, value) => onUpdate(id, { ...content, [key]: value });
  const setContent = (newContent) => onUpdate(id, newContent);
  const showAlignment = type !== 'divider';

  const alignmentControl = showAlignment ? (
    <Form.Group className="mb-3">
      <Form.Label>Alignment</Form.Label>
      <Form.Select value={content.align || 'left'} onChange={(e) => update('align', e.target.value)}>
        <option value="left">Left</option>
        <option value="center">Center</option>
        <option value="right">Right</option>
      </Form.Select>
    </Form.Group>
  ) : null;

  const EditorComponent = EDITOR_MAP[type];
  if (EditorComponent) {
    return (
      <div className="pagebuilder-editor-fields">
        {alignmentControl}
        <EditorComponent type={type} content={content} update={update} setContent={setContent} />
      </div>
    );
  }

  // Simple inline fallbacks
  switch (type) {
    case 'divider':
      return (
        <div className="pagebuilder-editor-fields pagebuilder-divider-preview">
          <hr className="pagebuilder-divider-line" />
          <p className="pagebuilder-divider-note">Visual divider � no settings needed.</p>
        </div>
      );

    case 'agendaSnippet':
      return (
        <div className="pagebuilder-editor-fields">
          {alignmentControl}
          <Form.Group className="mb-3">
            <Form.Label>Label</Form.Label>
            <Form.Control value={content.label || ''} onChange={(e) => update('label', e.target.value)} placeholder="e.g. Next Meeting Agenda" />
          </Form.Group>
          <Form.Group>
            <Form.Label>Meeting ID</Form.Label>
            <Form.Control value={content.meetingId || ''} onChange={(e) => update('meetingId', e.target.value)} placeholder="Meeting ID�" />
          </Form.Group>
        </div>
      );

    default:
      return <p className="pagebuilder-unknown-block">Unknown block type: {type}</p>;
  }
}
